import { ReactNode, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PASidebar from '../../PASidebar';
import { useScreenSize } from '../../../../../core/hooks/useScreenSize';
import { useWindowBreakpoints } from '../../../../../core/hooks/useWindowBreakpoints';
import { useGetHubResume } from '../../../hooks/ScheduleHub/useGetHubResume';

export const PA_ALLOWED_PATHS = [
  'plano-adaptativo/UUID/hub$',
  'plano-adaptativo/UUID/resumo$',
  'plano-adaptativo/UUID/completo$',
  'plano-adaptativo/UUID/disciplinas$',
];

export const PA_NOT_SHOW_BOTTOM_MENU_PATHS = [
  'plano-adaptativo/UUID/dia$',

  'plano-adaptativo$',
  'plano-adaptativo/configuracao/inicio$',
  'plano-adaptativo/UUID/configuracao/inicio$',
];

interface IPAMainCardProps {
  children?: ReactNode;
  paddingSize?: 'default' | 'small';
  className?: string;
  background?: string;
  'data-tour'?: string;
}

export function PAMainCard({
  children,
  className,
  paddingSize = 'default',
  background = 'bg-mono-color-white/60',
  'data-tour': dataTour,
}: IPAMainCardProps) {
  const [isSidebarClosed, setIsSidebarClosed] = useState(false);
  const { isError: isErrorResumo } = useGetHubResume();

  const screenSize = useScreenSize();
  const screeanBreakpoints = useWindowBreakpoints();
  const isMobile = screenSize <= screeanBreakpoints.lg;

  const padding = paddingSize === 'default' ? 'py-8' : 'py-8';

  const location = useLocation();

  const shouldShowMenu = useCallback(() => {
    if (isMobile) return false;

    const path = location.pathname;

    return (
      PA_ALLOWED_PATHS.some((pattern) => {
        const regex = new RegExp(pattern.replace('UUID', '[^/]+'));

        return regex.test(path);
      }) && isErrorResumo === false
    );
  }, [location.pathname, isMobile, isErrorResumo]);

  return (
    <div
      className={
        `flex w-full min-w-0 max-w-full flex-row ${background} md:m-4 md:w-[calc(100%-2rem)] md:rounded-[32px] md:p-8`
      }
    >
      <PASidebar
        isClosed={isSidebarClosed}
        onClose={() => setIsSidebarClosed(!isSidebarClosed)}
        show={shouldShowMenu()}
      />
      <div
        className={`min-w-0 grow bg-brand-color-primary-lighter py-3 md:p-8 ${shouldShowMenu() ? 'md:rounded-l-none' : 'md:rounded-[32px]'} md:rounded-r-[32px]`}
      >
        <main
          data-tour={dataTour}
          className={`h-full w-full min-w-0 rounded-[32px] border-hairline border-card-color-default  bg-mono-color-white/75 px-4 ${padding} shadow-level-2 lg:px-8 ${className}`}
        >
          {children}
        </main>
      </div>
    </div>
  );
}
